"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PhoneSchema = void 0;
const zod_1 = require("zod");
const _1 = require(".");
exports.PhoneSchema = zod_1.z.object({
    number: _1.ShortStringSchema,
    countryCode: _1.ShortStringSchema.optional(),
    areaCode: _1.ShortStringSchema.optional(),
    extension: _1.ShortStringSchema.optional(),
});
//# sourceMappingURL=phone.js.map